import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const PayBtn = styled.a`
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 24px;
        button {
            width: 100%;
        }
    }
`;
